import React from 'react';
import baseUrls from '../../data/baseUrls';
import './index.less';

interface IGivingButtonProps {
	groupToken?: string;
}

interface IGivingButtonState {
	isLoadingIframe: boolean;
	shouldShowModal: boolean;
}

export class GivingButton extends React.Component<IGivingButtonProps, IGivingButtonState> {
	private defaultOverflow;

	constructor(props) {
		super(props);

		this.state = {
			isLoadingIframe: true,
			shouldShowModal: false,
		};
	}

	componentDidMount() {
		this.defaultOverflow = document.body.style.overflow;
	}

	componentWillUnmount() {
		document.body.style.overflow = this.defaultOverflow;
	}

	openModal() {
		this.setState({ isLoadingIframe: true, shouldShowModal: true });
		document.body.style.overflow = 'hidden';
	}

	closeModal() {
		this.setState({ shouldShowModal: false });
		document.body.style.overflow = this.defaultOverflow;
	}

	iframeDidLoad() {
		this.setState({ isLoadingIframe: false });
	}

	isMobile() {
		return window.innerWidth <= 780;
	}

	render() {
		const { groupToken } = this.props;
		const giveLinkUrl = `${baseUrls.faithlife}/${groupToken}/give?embed=true`;

		return (
			<div className="giving-button-container">
				<button
					className="giving-button"
					onClick={() => (this.isMobile() ? window.open(giveLinkUrl) : this.openModal())}
				>
					Give
				</button>
				{this.renderModal(giveLinkUrl)}
			</div>
		);
	}

	renderModal(giveLinkUrl) {
		return this.state.shouldShowModal ? (
			<div className="fl-giving-modal">
				<div className="modal-content">
					<button className="close-button" onClick={() => this.closeModal()}>
						&times;
					</button>
					<iframe
						style={{ display: this.state.isLoadingIframe ? 'none' : 'block' }}
						src={giveLinkUrl}
						frameBorder="0"
						title="Giving Form"
						onLoad={() => this.iframeDidLoad()}
					/>
					{this.state.isLoadingIframe ? <div className="loading-spinner" /> : null}
				</div>
			</div>
		) : null;
	}
}
